'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Tooltip = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Tooltip, _React$Component);

  function Tooltip() {
    (0, _classCallCheck3.default)(this, Tooltip);
    return (0, _possibleConstructorReturn3.default)(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'getContent',
    value: function getContent() {
      if ((0, _isString2.default)(this.props.content)) {
        return this.props.content.split('\n').map(function (line, index) {
          return _react2.default.createElement('div', {
            key: index
          }, line);
        });
      }

      return this.props.content;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = (0, _uniqueId2.default)('os-tooltip');
      return _react2.default.createElement('div', {
        style: {
          display: 'inline-block'
        }
      }, _react2.default.createElement('div', {
        'data-tip': '',
        'data-for': id
      }, this.props.children), _react2.default.createElement(_reactTooltip2.default, {
        id: id,
        place: this.props.place,
        effect: 'solid',
        getContent: this.getContent
      }));
    }
  }]);
  return Tooltip;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.node,
  content: _propTypes2.default.node,
  place: _propTypes2.default.string
}, _temp), _applyDecoratedDescriptor(_class.prototype, 'getContent', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'getContent'), _class.prototype), _class);
exports.default = Tooltip;